<template>
  <el-dialog :visible="visible" :before-close="handleClose" title="故障/报警">
    <div class="alarm-detail-wrap">
      <div class="scroll">
        <div class="content">
          <template v-for="(item, index) in [faultThead, alarmThead]">
            <el-table :data="arr[index]" :key="index" border>
              <el-table-column
                align="center"
                v-for="col in item"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :width="col.width"
              ></el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      faultThead: [
        {
          label: '故障代码',
          prop: 'faultCode',
          width: '100px'
        },
        {
          label: '故障名称',
          prop: 'faultName'
        },
        {
          label: '传感器名称',
          prop: 'sensorName'
        },
        {
          label: '发生时间',
          prop: 'beginTimeD'
        }
      ],
      alarmThead: [
        {
          label: '目标浓度',
          prop: 'concentration',
          width: '100px'
        },
        {
          label: '物质名称',
          prop: 'alarmContent'
        },
        {
          label: '传感器名称',
          prop: 'sensorName'
        },
        {
          label: '发生时间',
          prop: 'beginTimeD'
        }
      ]
    };
  },
  computed: {
    faults() {
      return Array.isArray(this.data.faults) ? this.data.faults : [];
    },
    alarms() {
      return Array.isArray(this.data.alarms) ? this.data.alarms : [];
    },
    arr() {
      return [this.faults, this.alarms];
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss">
.alarm-detail-wrap {
  height: calc(100% - 430px);
  margin: 30px 10px 0;
  padding-bottom: 2px;
  overflow: hidden;
  .scroll {
    max-height: 100%;
    border: 1px solid #00ffff;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-right: -18px;
    position: relative;
  }
  & .header {
    position: sticky;
    top: 0;
    z-index: 9;
    background: #183449;
    text-align: center;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    color: $primary-text-color;
    border-right: 1px solid #00ffff;
  }
  & .content {
    border-right: 1px solid #00ffff;
    .el-table {
      color: white;
    }
    .el-table thead {
      color: #3ff;
    }
    .el-table--border td,
    .el-table--border th {
      border-right: 1px solid #00ffff;
      border-bottom: 1px solid #00ffff;
    }
    .el-table--border:nth-of-type(2) {
      border-top: 1px solid #00ffff;
    }
  }
}
</style>
